import type React from 'react'
import type { VariantProps } from 'class-variance-authority'
import { cn } from '../utils'
import { Button, buttonVariants } from './button'
import { LoadingSpinner } from './loading-spinner'

interface SubmitButtonProps
  extends React.ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  children: React.ReactNode
  isSubmitting: boolean
  disabled?: boolean
}

function getSpinnerClassName(variant: SubmitButtonProps['variant']) {
  if (variant === 'secondary') {
    return 'text-primary'
  }
  // TODO: Add more button variants as necessary
  return 'text-primary-foreground'
}

export function SubmitButton({
  children,
  isSubmitting = false,
  disabled,
  className,
  variant = 'default',
  ...props
}: SubmitButtonProps) {
  const spinnerClassName = getSpinnerClassName(variant)

  return (
    <Button
      disabled={disabled || isSubmitting}
      variant={variant}
      className={cn(
        className,
        'relative z-10',
        // Don't show disabled styles if the button is submitting
        isSubmitting ? 'disabled:cursor-pointer disabled:opacity-100' : '',
      )}
      {...props}
    >
      {isSubmitting ? <LoadingSpinner className={spinnerClassName} /> : children}
    </Button>
  )
}
